import { useState } from "react";
import AdultDashboardView from "../../components/adult/dashboard/AdultDashboardView";
import TeenDashboardView from "../../components/teen/dashboard/TeenDashboardView";
import Button from "../../components/ui/Button/Button";
import { useAuth } from "../../hooks/useAuth";
import { hasRole } from "../../utils/AuthUtils";

type DashboardView = "TEEN" | "ADULT";

const DashboardPage = () => {
  const { user } = useAuth();

  const teenAccess = hasRole(user?.roles, "TEEN");
  const adultAccess = hasRole(user?.roles, "ADULT");
  const dualRole = teenAccess && adultAccess;
  const defaultView: DashboardView = teenAccess ? "TEEN" : "ADULT";

  const [activeView, setActiveView] = useState<DashboardView>(defaultView);
  const currentView = dualRole ? activeView : defaultView;

  return (
    <main className="mx-auto max-w-4xl px-2 pb-12 pt-4 sm:px-6 sm:pt-5 md:pt-8">
      {dualRole ? (
        <div className="mt-4 grid grid-cols-2 gap-3 sm:mt-5 md:mt-6">
          <Button
            onClick={() => setActiveView("TEEN")}
            variant={activeView === "TEEN" ? "primary" : "outline"}
            className={`w-full ${
              activeView === "TEEN"
                ? "border-myteengig-primary bg-myteengig-primary text-white"
                : "border-myteengig-border bg-white text-myteengig-text-primary"
            }`}
          >
            As Teen
          </Button>
          <Button
            onClick={() => setActiveView("ADULT")}
            variant={activeView === "ADULT" ? "primary" : "outline"}
            className={`w-full ${
              activeView === "ADULT"
                ? "border-myteengig-primary bg-myteengig-primary text-white"
                : "border-myteengig-border bg-white text-myteengig-text-primary"
            }`}
          >
            As Adult
          </Button>
        </div>
      ) : null}

      {currentView === "TEEN" ? <TeenDashboardView /> : <AdultDashboardView />}
    </main>
  );
};

export default DashboardPage;
